import React, { useEffect } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Instructions from "./components/Instructions";
import BirthDetailsForm from "./components/BirthDetailsForm";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import GemstoneReady from "./components/GemstoneReady";
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import VerifyCode from "./pages/ForgotPassword/VerifyCode";
import CreateNewPassword from "./pages/ForgotPassword/CreateNewPassword";
import PasswordReset from "./pages/ForgotPassword/PasswordReset";

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Skip beforeunload on login page
    if (location.pathname === "/") {
      return;
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot_password" element={<ForgotPassword />} />
      <Route path="/verify_code" element={<VerifyCode />} />
      <Route path="/create_new_password" element={<CreateNewPassword />} />
      <Route path="/password-reset" element={<PasswordReset />} />

      <Route
        path="/gemstone"
        element={
          <div>
            <Navbar />
            <div className="container">
              <main className="main-content">
                <Instructions />
                <BirthDetailsForm />
              </main>
            </div>
          </div>
        }
      />
      <Route path="/gemstone-report/:id" element={<GemstoneReady />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
